
export const environment = {
    production: false,
    apiUrl: '/api',
    CARTO_API_KEY: 'cb1_2s52_1_c38cc12a1afb19b059319844',
    featureFlag: true,
    disableConsoleLogs: false,
    firebaseConfig: {
        apiKey: "AIzaSyCr-xcAWvYekWYLusrGQzDl8hZc8qXz70Q",
        authDomain: "instestore360.firebaseapp.com",
        projectId: "instestore360",
        storageBucket: "instestore360.firebasestorage.app",
        messagingSenderId: "104498623133",
        appId: "1:104498623133:web:1ed328e0098c1d959dda74",
        measurementId: "G-J3DWH1J0Y4",
        vapidKey: "BNhar7vskaOgMdAtU-pKx12EteGN3E6bIrZBhuRY6JLWmoTZKP1XO9a4LC_NKRTW-y2KN0QI4J7tViEhsHDChB0",
    },
    BLOB_URL: 'https://elxnsinsitestoredev001.blob.core.windows.net',

    // CSP Configuration for Dev Server
    cspConfig: {
        connectSrc: "'self' http: https: http://135.171.40.113:* ws://135.171.40.113:* blob:",
        scriptSrc: "'self' 'unsafe-inline' 'unsafe-eval' https://fonts.googleapis.com https://fonts.gstatic.com https://maps.googleapis.com",
        styleSrc: "'self' 'unsafe-inline' https://fonts.googleapis.com",
        fontSrc: "'self' https://fonts.gstatic.com",
        imgSrc: "'self' data: https: blob:",
        mediaSrc: "'self' data: https: blob:",
        frameSrc: "'self' https://app.powerbi.com",
        frameAncestors: "'none'",
        baseUri: "'self'",
        formAction: "'self'"
    },
    shopProfilingRemoteEntry: '/public/shop-profiling/mf-manifest.json',
    shopProfilingUiUrl: '/public/shop-profiling/index.html',
    spftRemoteEntry: '/public/spft/mf-manifest.json',
    spftUiUrl: '/public/spft/index.html',
};
